import React from "react";
import * as Styled from "./styled";

export default () => (
    <Styled.HeaderNotifications>
        <Styled.Bell />
        <Styled.Count>22</Styled.Count>
    </Styled.HeaderNotifications>
)